/**
 * @generated SignedSource<<d5728913e95803749b7cde0586a278f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CustomerType = "COMPANY" | "PERSON" | "%future added value";
export type EstimateDeclineReason = "FOUND_OTHER_SUPPLIER" | "NO_MORE_DEMAND" | "OTHER_REASON" | "PRICE_TOO_HIGH" | "QUALITY_TOO_LOW" | "%future added value";
export type EstimateStatus = "ACCEPTED" | "COMPLETED" | "DECLINED" | "DRAFT" | "SENT" | "%future added value";
export type LegalForm = "DE_EINGETRAGENER_KAUFMANN" | "DE_EINZELUNTERNEHMER" | "DE_GBR" | "DE_GMBH" | "DE_UG" | "%future added value";
export type EstimateLayoutQuery$variables = {
  webToken: string;
};
export type EstimateLayoutQuery$data = {
  readonly estimate: {
    readonly acceptedAt: any | null | undefined;
    readonly closingText: string | null | undefined;
    readonly company: {
      readonly bic: string | null | undefined;
      readonly city: string | null | undefined;
      readonly companyName: string | null | undefined;
      readonly companyRegistrationNumber: string | null | undefined;
      readonly email: string | null | undefined;
      readonly fax: string | null | undefined;
      readonly iban: string | null | undefined;
      readonly legalForm: LegalForm | null | undefined;
      readonly logoUrl: any | null | undefined;
      readonly managingDirectors: ReadonlyArray<{
        readonly name: string;
      } | null | undefined> | null | undefined;
      readonly phone: string | null | undefined;
      readonly registerCourt: string | null | undefined;
      readonly streetAddress: string | null | undefined;
      readonly taxNumber: string | null | undefined;
      readonly vatId: string | null | undefined;
      readonly zip: string | null | undefined;
    };
    readonly customer: {
      readonly city: string | null | undefined;
      readonly companyName: string | null | undefined;
      readonly firstName: string | null | undefined;
      readonly lastName: string | null | undefined;
      readonly salutation: string | null | undefined;
      readonly streetAddress: string | null | undefined;
      readonly type: CustomerType;
      readonly zip: string | null | undefined;
    };
    readonly declineNote: string | null | undefined;
    readonly declineReason: EstimateDeclineReason | null | undefined;
    readonly declinedAt: any | null | undefined;
    readonly estimateDate: any;
    readonly estimatePdf: string | null | undefined;
    readonly hasKleinunternehmerregelung: boolean;
    readonly id: string;
    readonly introductionText: string | null | undefined;
    readonly items: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly object: {
        readonly city: string | null | undefined;
        readonly name: string | null | undefined;
        readonly streetAddress: string | null | undefined;
        readonly zip: string | null | undefined;
      } | null | undefined;
      readonly quantity: number;
      readonly taxRate: number;
      readonly title: string;
      readonly unit: string | null | undefined;
      readonly unitPrice: number;
    }>;
    readonly number: number;
    readonly numberPrefix: string | null | undefined;
    readonly scopeOfWorkPdf: string | null | undefined;
    readonly status: EstimateStatus;
    readonly validityDate: any | null | undefined;
    readonly webEnabled: boolean;
    readonly webToken: string;
  } | null | undefined;
};
export type EstimateLayoutQuery = {
  response: EstimateLayoutQuery$data;
  variables: EstimateLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "webToken"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zip",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "webToken",
        "variableName": "webToken"
      }
    ],
    "concreteType": "Estimate",
    "kind": "LinkedField",
    "name": "estimate",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "legalForm",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fax",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iban",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bic",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registerCourt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyRegistrationNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyManagingDirector",
            "kind": "LinkedField",
            "name": "managingDirectors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salutation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "number",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberPrefix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EstimateItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unitPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Object",
            "kind": "LinkedField",
            "name": "object",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "estimateDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validityDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasKleinunternehmerregelung",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "introductionText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "closingText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "estimatePdf",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scopeOfWorkPdf",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "webToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "webEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declineReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declineNote",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "acceptedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declinedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EstimateLayoutQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EstimateLayoutQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "18fe46642c089810d124e38d8519149f",
    "id": null,
    "metadata": {},
    "name": "EstimateLayoutQuery",
    "operationKind": "query",
    "text": "query EstimateLayoutQuery(\n  $webToken: ID!\n) {\n  estimate(webToken: $webToken) {\n    id\n    company {\n      companyName\n      legalForm\n      streetAddress\n      zip\n      city\n      taxNumber\n      vatId\n      email\n      phone\n      fax\n      iban\n      bic\n      registerCourt\n      companyRegistrationNumber\n      managingDirectors {\n        name\n      }\n      logoUrl\n    }\n    customer {\n      type\n      salutation\n      firstName\n      lastName\n      companyName\n      streetAddress\n      zip\n      city\n    }\n    status\n    number\n    numberPrefix\n    items {\n      id\n      title\n      description\n      quantity\n      unitPrice\n      taxRate\n      unit\n      object {\n        name\n        streetAddress\n        zip\n        city\n      }\n    }\n    estimateDate\n    validityDate\n    hasKleinunternehmerregelung\n    introductionText\n    closingText\n    estimatePdf\n    scopeOfWorkPdf\n    webToken\n    webEnabled\n    declineReason\n    declineNote\n    acceptedAt\n    declinedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c454d15fda48c1a2e6a710b7e5de0a2";

export default node;
